import { render, staticRenderFns } from "./techTalentNew.vue?vue&type=template&id=783844ef&scoped=true"
import script from "./techTalentNew.vue?vue&type=script&lang=js"
export * from "./techTalentNew.vue?vue&type=script&lang=js"
import style0 from "./techTalentNew.vue?vue&type=style&index=0&id=783844ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783844ef",
  null
  
)

export default component.exports